'use strict';

/*
  Příjem - neshody
  např. mám 500 ks. Nejdříve přijem 300 ks jako dobrých, následně 200 ks jako neshoda
*/

/*global app*/
/*global services*/
/*global BasicItemForm*/
/*global invokeCallback*/
/*global createObjectCallBack*/
/*global isFloat*/
/*global isEmpty*/
/*global parseFloatK2*/
/*global compareNumbers*/
/*global formatAmountByUnit*/
/*global getAmountToUnit*/
/*global getAmountFromUnit*/
/*global getUnitByUnit*/
/*global sprintf*/
/*global wrrSuccess*/
/*global btBatch*/
/*global btArticle*/
/*global btLocation*/
/*global btHandlingUnit*/
/*global Promise*/
/*global resClose*/
/*global resSuccess*/
/*global resError*/
/*global weightNetto*/
/*global weightBrutto*/
/*global roundToDecimals*/

function ItemForm() {
  BasicItemForm.call(this, 'item-form--normal');

  this.$amountInput = null;
  this.$mismatchInput = null;
  this.$handingUnitInput = null;
  this.$handingUnitConfirmInput = null;

  this.amountUnit = null;
  this.origAmount = null;
  this.origMismatch = null;
  this.isArticleEanPrinted = false;

  this.init();
}

ItemForm.prototype = $.extend({}, BasicItemForm.prototype, {
  constructor: 'ItemForm',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    _this.confirm.contentDOM().on('click', '.item-form__menu', function () {
      _this.menu();

      return false;
    });

    _this.confirm.contentDOM().on('click', '.item-form__print', function () {
      _this.print();

      return false;
    });

    _this.confirm.contentDOM().on('click', '.item-form__print-ean', function () {
      _this.printEan();

      return false;
    });

    _this.confirm.contentDOM().on('click', '.item-form__add-ean', function () {
      _this.addEan();

      return false;
    });

    _this.confirm.contentDOM().on('click', '.item-form__change-weigth--netto', function () {
      _this.changeWeight(weightNetto);

      return false;
    });

    _this.confirm.contentDOM().on('click', '.item-form__change-weigth--brutto', function () {
      _this.changeWeight(weightBrutto);

      return false;
    });

    _this.confirm.contentDOM().on('click', '.item-form__choose-mismatch', function () {
      _this.chooseMismatch();

      return false;
    });

    _this.confirm.contentDOM().on('click', '.item-form__remove-mismatch', function () {
      _this.removeMismatch();

      return false;
    });

    _this.confirm.contentDOM().on('click', '.item-form__generate-location', function () {
      _this.generateLocation();

      return false;
    });

    _this.confirm.contentDOM().on('click', '.item-form__insert-location', function () {
      _this.insertLocation();

      return false;
    });

    _this.confirm.contentDOM().on('click', '.item-form__released', function () {
      _this.released();

      return false;
    });

    _this.confirm.contentDOM().on('focus', '.item-form__input--amount', function () {
      _this.insertAmount();
    });

    _this.confirm.contentDOM().on('change', '.item-form__input--amount', function () {
      if (_this.isAmountValid()) {
        _this.changeAmount();
      }
    });

    _this.confirm.contentDOM().on('change', '.item-form__input--package', function () {
      _this.changePackage();
    });

    _this.confirm.contentDOM().on('change', '.item-form__input--package-count', function () {
      _this.changePackage();
    });

    _this.confirm.contentDOM().on('keyup', '.item-form__input--handling-unit-confirm', function (e) {
      var keyCode = e.originalEvent.keyCode || e.originalEvent.which || e.originalEvent.charCode || e.originalEvent.code;
      if (keyCode === 13) {
        if (_this.isHandlingUnitValid()) {
          _this.save();
        } else {
          _this.$handlingUnitConfirmInput.val('');
        }

        return false;
      }
    });

    $('body').on('change', '.item-form__mismatch-option', function () {
      _this.changeMismatch();
    });

    $('body').on('keyup', '.item-form__input--scan', function () {
      _this.changeInputScan($(this).val());
    });
  },

  //----------------------------------------------------------------------------

  onAfterChangeMismatch: function onAfterChangeMismatch(mismatchId) {
    var _this = this;

    if (mismatchId === app.param('wrong_package_mismatch_id')) {
      _this.removeMismatch();
      _this.wrongPackage();
    }

    return _this;
  },

  onAfterInitForm: function onAfterInitForm() {
    var _this = this;

    var promise = Promise.resolve();

    if (app.param('is_pematex')) {
      /*
      nove chteji az pri ukladani
      promise = promise.then(function () {
        return _this.doScanLocation();
      });

      promise = promise.then(function () {
        return _this.doConfirmLocation();
      });
      */

      promise = promise.then(function () {
        return _this.doConfirmArticle();
      });

      promise = promise.then(function () {
        return _this.doConfirmBatch();
      });

      promise = promise.then(function () {
        return _this.doInsertAmount();
      });
    }

    if (app.param('is_hopefix')) {
      promise = promise.then(function () {
        return _this.doAutoFillLocation();
      });
    }

    promise = promise.finally(function () {
      _this.initSafetyElement();

      _this.viewOnScreenMessages(function () {
        //toto je pouze u prijmu - tam handling unit nemame
        _this.initPackage();

        //nakonec nastavime focus na toto pole - potreba mit takto, nekdy to bez toho nejde
        setTimeout(function () {
          _this.$handlingUnitConfirmInput.focus();
        }, 500);
      });
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  getWarehouseId: function getWarehouseId() {
    var _this = this;

    return _this.settings.editedLocation === 'FromLocation' ? _this.getFormFloatValue('FromStockId') : _this.getFormFloatValue('ToStockId');
  },

  getAmount: function getAmount() {
    var _this = this;

    return parseFloatK2(_this.$amountInput.val());
  },

  getAmountRatio: function getAmountRatio() {
    var _this = this;

    return parseFloatK2(_this.getFormValue('AmountRatio'));
  },

  isMismatch: function isMismatch() {
    var _this = this;

    return _this.$container.find('[name$="[Mismatch]"]:checked').length > 0;
  },

  //----------------------------------------------------------------------------

  menu: function menu() {
    var _this = this;

    var list = [];
    list.push({ id: 'location_notification', abbr: app.t('location_notification') });

    app.selectValue({ list: list }, function (value) {
      switch (value) {
        case 'location_notification' : return _this.sendLocationNotification();
      }
    });

    return _this;
  },

  print: function print() {
    var _this = this;

    var list = [];
    list.push({ id: 'address', abbr: app.t('address_label') });
    list.push({ id: 'customer', abbr: app.t('customer_label') });
    list.push({ id: 'article', abbr: app.t('article_ean') });

    app.selectValue({ list: list }, function (value) {
      switch (value) {
        case 'address' : return app.printer.printAddressLabel(_this.$handlingUnitInput.val());
        case 'customer' : return app.printer.printCustomerLabel(_this.getWebDocumentItemRID(), _this.getAmount());
        case 'article' : return app.printer.printArticleEan(_this.getWebDocumentItemRID(), { Package: _this.getPackage(), SerialNumber: _this.getSerialNumber(), SerialNumberSize: _this.getSerialNumberSize() });
      }
    });

    return _this;
  },

  printEan: function printEan() {
    var _this = this;

    app.printer.printArticleEan(_this.getWebDocumentItemRID(), { Package: _this.getPackage(), SerialNumber: _this.getSerialNumber(), SerialNumberSize: _this.getSerialNumberSize() }, function (printed) {
      _this.isArticleEanPrinted = printed;
    });

    return _this;
  },

  addEan: function addEan() {
    var _this = this;

    services.get('article-service').addEan(_this.origData.ArticleId);

    return _this;
  },

  changeWeight: function changeWeight(weightType) {
    var _this = this;

    services.get('article-service').changeWeight(_this.origData.ArticleId, weightType, function (weight) {
      if (weight <= 0) {
        return;
      }

      switch (weightType) {
        case weightNetto : {
          _this.origData.UnitWeightNetto = parseFloatK2(weight);

          _this.$container.find('.item-form__change-weigth--netto').removeClass('btn-danger');

          if (_this.origData.UnitWeightBrutto <= 0) {
            _this.$container.find('.item-form__change-weigth--brutto').trigger('click');
          }
        }

        break;
        case weightBrutto : {
          _this.origData.UnitWeightBrutto = parseFloatK2(weight);

          _this.$container.find('.item-form__change-weigth--brutto').removeClass('btn-danger');

          if (_this.origData.UnitWeightNetto <= 0) {
            _this.$container.find('.item-form__change-weigth--netto').trigger('click');
          }
        }

        break;
      }
    });

    return _this;
  },

  wrongPackage: function wrongPackage() {
    var _this = this;

    app.getValue(app.t('item_form.insert_new_package'), function (value) {
      //zasleme notifikaci

      var data = {
        ArticleId: _this.origData.ArticleId,
        Location: _this.getFormValue(_this.settings.editedLocation),
        Package: _this.origData.Package,
        PackageNew: value
      };

      _this.confirm.block();
      app.getFormation('common_process:mismatch_wrong_package', data, function (res) {
        _this.confirm.unBlock();

        if (res.msg === 'SUCCESS' && res.data.Result === wrrSuccess) {
          app.showMessageHtml(app.t('item_form.new_package_notification'));
        } else {
          app.viewErrorMessage(res.error);
        }
      });
    });

    return _this;
  },

  saveAmount: function saveAmount(amount) {
    var _this = this;

    _this.$container.find('[name$="[Amount]"]').val(amount);

    return _this;
  },

  saveIsIncreasedAmount: function saveIsIncreasedAmount(isIncreased) {
    var _this = this;

    if (isIncreased === undefined) {
      isIncreased = true;
    }

    _this.$container.find('[name$="[IsIncreasedAmount]"]').val(isIncreased ? 1 : 0);

    return _this;
  },

  saveIsReleased: function saveIsReleased() {
    var _this = this;

    _this.$container.find('[name$="[IsReleased]"]').val(1);

    return _this;
  },

  changeMismatch: function changeMismatch() {
    var _this = this;

    var modal = services.get('modal');
    if (modal.isOpen()) {
      var $mismatch = modal.contentDOM().find('input:checked');
      var mismatchId = $mismatch.length ? parseInt($mismatch.val()) : 0;
      var mismatchTitle = $.trim($mismatch.parent().text());

      _this.saveMismatch(mismatchId, mismatchTitle);

      _this.onAfterChangeMismatch(mismatchId);

      modal.close();
    }
  },

  isAllowedInputScan: function isAllowedInputScan() {
    var _this = this;

    if ($('body').find('.k2-keyboard:visible').length) {
      return false;
    }

    return _this.settings.allowedScanBarcodes;
  },

  changeInputScan: function changeInputScan(value) {
    var _this = this;

    if (!_this.isAllowedInputScan()) {
      return;
    }

    services.get('barcode-service').find(value, _this.getWarehouseId(), function (data) {
      var message = '';

      switch (data.BarcodeType) {
        case btBatch : {
          if (data.Article === _this.origData.ArticleId) {
            return _this.incAmount();
          }

          message = sprintf(app.t('barcode.mismatch_article'), value, _this.origData.ArticleName);
        }

        break;
        case btArticle : {
          if (data.Id === _this.origData.ArticleId) {
            return _this.incAmount();
          }

          message = sprintf(app.t('barcode.mismatch_article'), value, _this.origData.ArticleName);
        }

        break;
        case btLocation : {
          var locationId = _this.$container.find('[name$="[' + _this.settings.editedLocation + 'Id]"]').val();

          if (compareNumbers(data.Id, locationId) === 0) {
            _this.settings.isLocationScanned = true;

            return _this.save();
          }

          message = sprintf(app.t('barcode.mismatch_location'), value, _this.origData.LocationTo);
        }

        break;
        default : {
          message = app.t('barcode.unknown');
        }
      }

      if (!isEmpty(message)) {
        app.showMessageHtml(message);
      }
    });

    return _this;
  },

  getMismatch: function getMismatch() {
    var _this = this;

    var $mismatch = _this.$container.find('[name$="[Mismatch]"]:checked');
    var mismatch = $mismatch.length ? parseInt($mismatch.val()) : 0;

    //pri volbe vice baleni neshodu zrusim
    if (mismatch !== 0 && mismatch === app.param('more_packages_mismatch_id')) {
      mismatch = 0;
    }

    return mismatch;
  },

  saveMismatch: function saveMismatch(mismatchId, mismatchTitle) {
    var _this = this;

    if (mismatchId) {
      _this.$container.find('[name$="[Mismatch]"]:checked').prop('checked', false).parent().removeClass('active');
      _this.$container.find('[name$="[Mismatch]"][value="' + mismatchId + '"]').prop('checked', true).parent().addClass('active');
      _this.$container.find('[name$="[MismatchTitle]"]').val(mismatchTitle);
    }

    return _this;
  },

  chooseMismatch: function chooseMismatch() {
    var _this = this;

    var modal = services.get('modal');
    modal.open({
      title: app.t('item_form.choose_mismatch'),
      height: 'auto',
      width: 'md',
      content: _this.$container.find('.item-form__mismatch-list').html()
    });

    return _this;
  },

  removeMismatch: function removeMismatch() {
    var _this = this;

    _this.$container.find('[name$="[Mismatch]"]:checked').prop('checked', false).parent().removeClass('active');
    _this.$container.find('[name$="[MismatchTitle]"]').val('');

    return _this;
  },

  chooseRequiredPackage: function chooseRequiredPackage(callback) {
    var _this = this;

    var data = {
      ArticleId: _this.origData.ArticleId,
      LocationId: _this.getFormFloatValue(_this.settings.editedLocation + 'Id'),
      StockId: _this.getWarehouseId(),
    };

    _this.confirm.block();
    services.get('warehouse-service').getArticlePackage(data, function (res, resData) {
      _this.confirm.unBlock();

      if (res === resSuccess) {
        _this.$requiredPackage.val(resData.value);

        if (resData.list.length > 1) {
          _this.settings.requiredInsertAmount = true;
        }

        _this.settings.isBatchChoosen = true;

        invokeCallback(callback, true);
      } else {
        invokeCallback(callback, false);
      }
    });

    return _this;
  },

  getPackage: function getPackage() {
    var _this = this;

    if (_this.settings.allowedPackage) {
      return getAmountToUnit(parseFloatK2(_this.$package.val()), _this.amountUnit);
    } else {
      return parseFloatK2(_this.$requiredPackage.val());
    }
  },

  getPackageUnits: function getPackageUnits() {
    var _this = this;

    return getAmountToUnit(parseFloatK2(_this.$packageUnits.val()), _this.amountUnit);
  },

  getPackageCount: function getPackageCount() {
    var _this = this;

    return parseFloatK2(_this.$packageCount.val());
  },

  getSerialNumber: function getSerialNumber() {
    var _this = this;

    return _this.$container.find('[name$="[SerialNumber]"]').val();
  },

  getSerialNumberSize: function getSerialNumberSize() {
    var _this = this;

    return _this.$container.find('[name$="[SerialNumberSize]"]').val();
  },

  resetAmount: function resetAmount() {
    var _this = this;

    _this.saveAmount(_this.origData.Amount);
    _this.saveIsIncreasedAmount(false);
    _this.removeMismatch();

    return _this;
  },

  checkDisposition: function checkDisposition(amountOrig, amount) {
    var _this = this;

    if (!_this.settings.allowedCheckDisposition) {
      return _this;
    }

    var data = {
      DocumentType: _this.getFormValue('DocumentType'),
      ArticleId: _this.origData.ArticleId,
      BatchId: _this.origData.BatchId,
      LocationId: _this.getFormFloatValue(_this.settings.editedLocation + 'Id'),
      StockId: _this.getWarehouseId(),
      RequestedAmount: roundToDecimals((amount - amountOrig) * _this.getAmountRatio(), 2),
      DocRID: _this.origData.DocRID,
      TradingPartnerId: _this.origData.CustomerId,
      IncludeAssigned: _this.settings.allowedIncludeAssigned ? 1 : 0
    };

    _this.confirm.block();
    services.get('warehouse-service').getDisposition(data, function (res, availableAmount) {
      _this.confirm.unBlock();

      if (!res) {
        var message = sprintf(app.t('item_form.disposition_is_not_available'), availableAmount + ' ' + _this.amountUnit);
        app.showMessageHtml(message);

        _this.resetAmount();
      }
    });

    return _this;
  },

  changeAmount: function changeAmount() {
    var _this = this;

    var amountOrig = parseFloatK2(_this.origData.Amount);
    var amount = _this.getAmount();

    //1. pri shode koncime rovnou
    if (amountOrig === amount) {
      return _this;
    }

    //2. pri nizsim mnozstvi
    if (amountOrig > amount) {
      if (_this.settings.allowedAutoMismatch) {
        _this.saveMismatch(app.param('low_amount_mismatch_id'), app.param('low_amount_mismatch_title'));
      } else if (!_this.getMismatch() && amount > 0) {
        _this.saveMismatch(app.param('more_packages_mismatch_id'), app.param('more_packages_mismatch_title'));
      } else if (!_this.getMismatch()) {
        _this.saveMismatch(app.param('low_amount_mismatch_id'), app.param('low_amount_mismatch_title'));
      }

      return _this;
    }

    //3. jinak mame navysene mnozstvi
    if (_this.settings.allowedHighAmount) {
      //pokud je povoleno navysovat mnozstvi, neresim - melo by byt jen pro pripad nove prevodky

      //overim dispozici
      _this.checkDisposition(amountOrig, amount);
      return _this;
    }

    if (_this.settings.allowedAutoMismatch) {
      _this.saveMismatch(app.param('high_amount_mismatch_id'), app.param('high_amount_mismatch_title'));
    }

    if (_this.settings.isOutgoingControl) {
      //v pripade vystupni kontroly musime resit zvlast ...

      if (_this.origData.IsAllowedIncreaseAmount === '1') {
        services.get('confirm-service').confirm({
          title: app.t('item_form.increase_amount'),
          content: app.t('item_form.increase_amount_help')
        }, function (ret) {
          if (ret) {
            //ulozime priznak navyseneho mnozstvi
            _this.saveIsIncreasedAmount();

            //overime dispozici
            _this.checkDisposition(amountOrig, amount);
          }
        });
      }

      return _this;
    }

    if (_this.origData.IsAllowedIncreaseAmount !== '1') {
      //pokud nemam povoleno navysovat mnozstvi, nebo nejsem na vystupni kontrole, vratim zpet a upozornim
      _this.resetAmount();

      app.viewErrorMessage(app.t('item_form.amount_is_high_then_original_amount'));

      return _this;
    }

    //nakonec overime dispozici
    _this.checkDisposition(amountOrig, amount);

    return _this;
  },

  incAmount: function incAmount() {
    var _this = this;

    if (_this.settings.allowedPackage) {
      var packageCount = parseFloatK2(_this.$packageCount.val());

      _this.$packageCount.val(++packageCount);

      _this.changePackage();
    } else {
      var amount = _this.getAmount();

      _this.saveAmount(++amount);
    }

    return _this;
  },

  insertAmount: function insertAmount(callback) {
    var _this = this;

    if (_this.settings.allowedPackage) {
      return _this;
    }

    var unit = getUnitByUnit(_this.amountUnit);
    var amount = getAmountFromUnit(_this.$amountInput.val(), _this.amountUnit);

    if (amount === 0) {
      amount = '';
    }

    app.getValueWithRes({ content: 'Zadejte množství', value: amount, placeholder: amount, suffix: unit }, function (res, resData) {
      if (res === resSuccess) {
        var amount = resData;
        amount = getAmountToUnit(amount, _this.amountUnit);
        amount = formatAmountByUnit(amount, _this.amountUnit);

        _this.$amountInput.val(amount);
        _this.$amountInput.change();
      }

      invokeCallback(callback, res);
    });

    return _this;
  },

  changePackage: function changePackage() {
    var _this = this;

    if (!_this.settings.allowedPackage) {
      return _this;
    }

    var packageAmount = parseFloatK2(_this.$package.val());
    var packageCount = parseFloatK2(_this.$packageCount.val());

    if (packageAmount && packageCount) {
      var amountOrig = parseFloatK2(_this.origData.Amount);
      var amount = packageAmount * packageCount;
      amount = getAmountToUnit(amount, _this.amountUnit);

      if (amount > amountOrig) {
        amount = amountOrig;

        app.viewErrorMessage(app.t('item_form.receipt_quantity_is_higher'));
      }

      amount = formatAmountByUnit(amount, _this.amountUnit);

      _this.saveAmount(amount);
    } else {
      _this.$amountInput.val(0);
    }

    return _this;
  },

  insertPackage: function insertPackage() {
    var _this = this;

    app.getValue(app.t('item_form.insert_package'), function (ret) {
      if (!ret) {
        return;
      }

      _this.$package.val(ret);
      _this.changePackage();
    });

    return _this;
  },

  sendLocationNotification: function sendLocationNotification() {
    var _this = this;

    app.getFormation('common_process:send_location_notification', { LocationId: _this.getFormValue(_this.settings.editedLocation + 'Id') }, function (res) {
      if (res.msg === 'SUCCESS') {
        app.viewSuccessMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  getSrcDataForLocation: function getSrcDataForLocation() {
    var _this = this;

    //u prijmu nebudeme zadavat sklad, protoze prijimame na jiny nez, ktery je na dokladu

    return {
      DocumentType: _this.getFormValue('DocumentType'),
      Status: _this.getFormValue('Status'),
      WebDocumentRID: _this.getFormValue('WebDocumentRID'),
      TransportType: _this.getFormValue('TransportType'),
      StockId: _this.settings.isReceiptProcess ? app.param('active_warehouse_id') : _this.getWarehouseId(),
      ArticleId: _this.getFormValue('ArticleId'),
      Amount: _this.getAmount() * _this.getAmountRatio(),
      BatchId: _this.getFormValue('BatchId'),
      Package: _this.getPackage(),
      Location: _this.getFormValue(_this.settings.editedLocation + ''),
      LocationId: _this.getFormValue(_this.settings.editedLocation + 'Id'),
      AreaId: _this.getFormValue('AreaId')
    };
  },

  insertLocation: function insertLocation(callback) {
    var _this = this;

    var srcData = _this.getSrcDataForLocation();

    _this.locationService.scanLocation(srcData, function (res, resData) {
      if (res === resClose || res === resError || !resData.LocationId) {
        return invokeCallback(callback, false);
      }

      _this.setFormValue(_this.settings.editedLocation, resData.Location);
      _this.setFormValue(_this.settings.editedLocation + 'Id', resData.LocationId);
      _this.setFormValue('AreaId', resData.AreaId);
      _this.setFormBoolValue('IsFromLocationOneArticle', resData.IsOneArticle);

      _this.settings.isLocationScanned = true;
      _this.settings.isArticleScanned = false;
      _this.settings.isBatchChoosen = false;

      invokeCallback(callback, true);
    });

    return _this;
  },

  doGenerateLocation: function doGenerateLocation(callback) {
    var _this = this;

    var confirm = services.get('confirm');
    confirm.close();

    _this.confirm.block();

    var srcData = _this.getSrcDataForLocation();
    _this.locationService.generateLocation(srcData, function (res, resData) {
      _this.confirm.unBlock();

      if (res === resError || resData.LocationId === 0) {
        if (callback) {
          return invokeCallback(callback, false);
        } else {
          //nenalezeno
          return services.get('output-service').showMessage({ title: app.t('item_form.location_not_found'), content: app.t('item_form.location_not_found_help') });
        }
      }

      _this.setFormValue(_this.settings.editedLocation, resData.Location);
      _this.setFormValue(_this.settings.editedLocation + 'Id', resData.LocationId);
      _this.setFormValue('AreaId', resData.AreaId);
      _this.setFormBoolValue('IsFromLocationOneArticle', resData.IsOneArticle);

      _this.settings.isLocationScanned = false;
      _this.settings.isArticleScanned = false;
      _this.settings.isBatchChoosen = false;

      if (compareNumbers(srcData.Amount, resData.Amount) < 0) {
        _this.setFormFloatValue('Amount', resData.Amount / _this.getAmountRatio());
      }

      invokeCallback(callback, true);
    });

    return _this;
  },

  generateLocation: function generateLocation() {
    var _this = this;

    var confirm = services.get('confirm');
    confirm.open({
      title: app.t('item_form.generate_location'),
      height: 'auto',
      width: 'md',
      content: app.t('item_form.generate_location_help'),
      buttonsSize: 'lg',
      confirmCallBack: createObjectCallBack(_this, 'doGenerateLocation')
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  released: function released() {
    var _this = this;

    _this.saveIsReleased();
    _this.save();

    return _this;
  },

  //----------------------------------------------------------------------------

  isAmountValid: function isAmountValid() {
    var _this = this;

    _this.$amountInput.parent().removeClass('has-error');

    if (!isFloat(_this.$amountInput.val())) {
      _this.$amountInput.parent().addClass('has-error');

      return false;
    }

    return true;
  },

  isHandlingUnitValid: function isHandlingUnitValid() {
    var _this = this;

    var handlingUnit = _this.$handlingUnitInput.val();
    var handlingUnitConfirm = _this.$handlingUnitConfirmInput.val();

    if (_this.settings.requiredConfirmHandlingUnit || !isEmpty(handlingUnitConfirm)) {
      _this.$handlingUnitConfirmInput.parent().removeClass('has-error');

      handlingUnit = handlingUnit.toLowerCase();
      handlingUnitConfirm = handlingUnitConfirm.toLowerCase();

      if (handlingUnit !== handlingUnitConfirm) {
        _this.$handlingUnitConfirmInput.parent().addClass('has-error');

        return false;
      }
    }

    return true;
  },

  isPackageValid: function isPackageValid() {
    var _this = this;

    var packageAmount = parseFloatK2(_this.$package.val());
    var packageSize = parseFloatK2(_this.origData.PackageSize);

    if (_this.settings.allowedPackage) {
      _this.$package.parent().removeClass('has-error');

      if (packageAmount <= 0) {
        app.showMessageHtml(app.t('item_form.package_failed'));

        _this.$package.parent().addClass('has-error');
        return false;
      }

      if (_this.origData.IsRequiredWholePackages === '1') {
        if (packageAmount !== packageSize) {
          app.showMessageHtml(app.t('item_form.package_size_failed'));

          _this.$package.parent().addClass('has-error');
          return false;
        }
      }
    }

    return true;
  },

  isFormValid: function isFormValid() {
    var _this = this;

    var res = true;
    if (!_this.isAmountValid()) {
      res = false;
    }

    var amount = _this.getAmount();
    var mismatchId = _this.getMismatch();

    if (_this.settings.isReceiptProcess && !amount) {
      app.viewErrorMessage(app.t('item_form.insert_amount'));

      res = false;
    }

    if (res) {
      if (_this.settings.isPickingProcess || _this.settings.isTransferNoteProcess) {
        if (mismatchId && amount === _this.origAmount) {
          if (mismatchId !== app.param('not_processable_mismatch_id')) {
            app.viewErrorMessage(app.t('item_form.mismatch_not_changed_amount'));

            res = false;
          }
        }
      }
    }

    if (res) {
      if (!_this.settings.isOutgoingControl) {
        //pokud je vse v poradku a nejsme na vystupni kontrole, tak jeste overime mnozstvi
        if (amount > _this.origAmount) {
          if (_this.origData.IsAllowedIncreaseAmount !== '1' && !_this.settings.allowedHighAmount) {
            //pokud mam zadane mnozstvi vetsi, nez originalni, tak bych nemel dovolit ulozit
            app.viewErrorMessage(app.t('item_form.amount_is_high_then_original_amount'));

            res = false;
          }
        }

        if (amount < _this.origAmount && !mismatchId) {
          if (!_this.settings.allowedLowAmount) {
            //pokud mam zadane mnozstvi mensi, nez originalni, tak bych nemel dovolit ulozit
            app.viewErrorMessage(app.t('item_form.amount_is_low_then_original_amount'));

            res = false;
          }
        }
      }
    }

    if (res && !_this.isHandlingUnitValid()) {
      res = false;
    }

    if (res && !_this.isPackageValid()) {
      res = false;
    }

    return res;
  },

  //----------------------------------------------------------------------------

  initPackage: function initPackage() {
    var _this = this;

    if (_this.settings.allowedPackage) {
      _this.changePackage();

      //nelze pouzit package, jedna se o klicove slovo

      var packageValue = parseFloatK2(_this.origData.Package);
      var packageSize = parseFloatK2(_this.origData.PackageSize);

      if (packageSize > 0) {
        /*
        app.showMessageHtml(sprintf(app.t('item_form.required_package_size'), _this.origData.PackageSize), function () {
          _this.insertPackage();
        });
        */

        _this.$package.val(packageSize);
        _this.$package.addClass('form-control--highlighted');
        _this.changePackage();
      } else if (packageValue > 0) {
        _this.$package.addClass('form-control--highlighted');
        _this.changePackage();
      } else {
        _this.insertPackage();
      }
    }

    return _this;
  },

  initForm: function initForm(data) {
    var _this = this;

    data.UnitWeightNetto = parseFloatK2(data.UnitWeightNetto);
    data.UnitWeightBrutto = parseFloatK2(data.UnitWeightBrutto);

    _this.initFormBasic(data);

    _this.$amountInput = _this.$container.find('.item-form__input--amount');
    _this.$mismatchInput = _this.$container.find('.item-form__input--mismatch');
    _this.$handlingUnitInput = _this.$container.find('.item-form__input--handling-unit');
    _this.$handlingUnitConfirmInput = _this.$container.find('.item-form__input--handling-unit-confirm');
    _this.$requiredPackage = _this.$container.find('.item-form__required-package');
    _this.$package = _this.$container.find('.item-form__input--package');
    _this.$packageUnits = _this.$container.find('.item-form__input--package-units');
    _this.$packageCount = _this.$container.find('.item-form__input--package-count');

    _this.amountUnit = _this.$container.find('[name$="[Unit]"]').val();
    _this.origAmount = _this.getAmount();
    _this.origMismatch = _this.$container.find('[name$="[Mismatch]"]:checked').val();
    _this.origMismatch = _this.origMismatch ? parseInt(_this.origMismatch) : 0;
    _this.isArticleEanPrinted = false;

    var packageValue = getAmountFromUnit(data.Package, data.Unit);
    var packageUnits = getAmountFromUnit(data.PackageUnits, data.Unit);

    _this.$package.val(packageValue);
    _this.$packageUnits.val(packageUnits > 0 ? packageUnits : '');

    if (!_this.settings.showPrintButton) {
      _this.$container.find('.item-form__print').hide();
    }

    if (!_this.settings.showAddEan) {
      _this.$container.find('.item-form__print-ean').hide();
    }

    if (!_this.settings.showAddEan) {
      _this.$container.find('.item-form__add-ean').hide();
    }

    if (!_this.settings.showWeigthButton) {
      _this.$container.find('.item-form__change-weigth--netto').hide();
      _this.$container.find('.item-form__change-weigth--brutto').hide();
    } else {
      if (data.UnitWeightNetto === 0) {
        _this.$container.find('.item-form__change-weigth--netto').addClass('btn-danger');
      }

      if (data.UnitWeightBrutto === 0) {
        _this.$container.find('.item-form__change-weigth--brutto').addClass('btn-danger');
      }
    }

    if (!_this.settings.showLocationFrom) {
      _this.$container.find('.item-form__location-from').hide();
    }

    if (!_this.settings.showLocationTo) {
      _this.$container.find('.item-form__location-to').hide();
    }

    if (!_this.settings.allowedChangeLocation) {
      _this.$container.find('.item-form__location-btns').hide();
    }

    if (!_this.settings.allowedReleaseItem || _this.origMismatch !== app.param('low_amount_mismatch_id')) {
      _this.$container.find('.item-form__released-btns').hide();
    }

    if (!_this.settings.allowedHandlingUnit) {
      _this.$container.find('.item-form__handing-unit').hide();
    }

    if (_this.settings.allowedScanBarcodes) {
      _this.$amountInput.val(1);

      if (_this.getPackageCount() <= 0) {
        _this.$packageCount.val(1);
      }
    }

    if (!_this.settings.allowedPackage) {
      _this.$container.find('.item-form__package').hide();
    } else {
      _this.$amountInput.attr('readonly', true);
      _this.$amountInput.parent().prepend('<div class="input-group-addon input-group-addon--prefix"><span class="value-prefix">' + _this.origData.Amount + '</span></div>');
    }

    if (_this.settings.allowedRequiredPackage) {
      _this.$requiredPackage.attr('readonly', false);
    }

    this.onAfterInitForm();
  },

  deinitForm: function deinitForm() {
    var _this = this;

    _this.confirm.content('');

    return _this;
  },

  //----------------------------------------------------------------------------

  isRequiredChooseBatch: function isRequiredChooseBatch() {
    var _this = this;

    if (!_this.settings.allowedRequiredPackage) {
      return false;
    }

    if (_this.getFormBoolValue('IsFromLocationOneArticle')) {
      return false;
    }

    if (_this.settings.isBatchChoosen) {
      return false;
    }

    return true;
  },

  isRequiredConfirmArticle: function isRequiredConfirmArticle() {
    var _this = this;

    if (!services.get('warehouse-service').isRequiredConfirmArticle(_this.getWarehouseId())) {
      return false;
    }

    if (_this.settings.isReceiptProcess) {
      return false;
    }

    if (_this.settings.isArticleScanned) {
      return false;
    }

    if (_this.settings.editedLocation !== 'FromLocation') {
      return false;
    }

    if (_this.getAmount() === 0) {
      return false;
    }

    return !_this.getFormBoolValue('IsFromLocationOneArticle');
  },

  confirmArticle: function confirmArticle(callback) {
    var _this = this;

    services.get('barcode-service').scanAndFindBarcode(btArticle, sprintf(app.t('item_form.insert_article'), _this.origData.ArticleName, _this.origData.ArticleAbbr), 0, function (res, resData) {
      if (res === resClose) {
        invokeCallback(callback, false);
      } else if (res === resError) {
        app.viewErrorMessage(app.t('barcode.unknown'), function () {
          invokeCallback(callback, false);
        });
      } else if (res === resSuccess && resData.Id === _this.origData.ArticleId) {
        //ulozime si, ze bylo naskenovano
        _this.settings.isArticleScanned = true;

        invokeCallback(callback, true);
      } else {
        app.viewErrorMessage(app.t('article.mismatch'), function () {
          invokeCallback(callback, false);
        });
      }
    });

    return _this;
  },

  isRequiredConfirmLocationOrHandlingUnit: function () {
    var _this = this;

    if (!services.get('warehouse-service').isLocationRecord(_this.getWarehouseId())) {
      return false;
    }

    if (!services.get('warehouse-service').isRequiredConfirmLocation(_this.getWarehouseId())) {
      return false;
    }

    if (_this.settings.isReceiptProcess) {
      return false;
    }

    if (!_this.settings.requiredConfirmLocation) {
      return false;
    }

    if (_this.settings.isLocationScanned) {
      return false;
    }

    if (_this.getFormFloatValue('HandlingUnitRID')) {
      return false;
    }

    if (_this.getMismatch() && _this.getMismatch() === app.param('not_processable_mismatch_id') && _this.getAmount() === _this.origAmount) {
      return false;
    }

    if (_this.getAmount() === 0) {
      return false;
    }

    return true;
  },

  compareLocation: function compareLocation(locationId2, callback) {
    var _this = this;

    var locationId = _this.getFormFloatValue(_this.settings.editedLocation + 'Id');
    if (compareNumbers(locationId, locationId2) === 0) {
      //ulozime si, ze bylo potvrzeno
      _this.settings.isLocationScanned = true;

      invokeCallback(callback, true);
    } else {
      app.viewErrorMessage(app.t('location.confirm_location_invalid'), function () {
        invokeCallback(callback, false);
      });
    }

    return _this;
  },

  confirmLocation: function confirmLocation(callback) {
    var _this = this;

    var stockId = _this.getWarehouseId();
    var location = _this.getFormValue(_this.settings.editedLocation);

    _this.locationService.scanLocation({ StockId: stockId, Location: location }, function (res, resData) {
      if (res === resClose) {
        return invokeCallback(callback, false);
      }

      if (res === resError || !resData.LocationId) {
        return _this.confirmLocation(callback);
      }

      return _this.compareLocation(resData.LocationId, callback);
    });

    return _this;
  },

  confirmLocationOrHandlingUnit: function confirmLocationOrHandlingUnit(callback) {
    var _this = this;

    if (_this.settings.isPickingProcess || _this.settings.editedLocation === 'FromLocation') {
      //u vychystani pouze potvrzujeme
      _this.confirmLocation(callback);
    } else {
      //u zaskladneni bude potvrzujeme, nebo davame na MJ
      services.get('barcode-service').scanAndFind(sprintf(app.t('barcode.confirm_location_or_scan_handling_unit'), _this.getFormValue(_this.settings.editedLocation)), app.param('active_warehouse_id'), function (res, resData) { //nepredavame sklad!
        if (res !== resSuccess) {
          return;
        }

        switch (resData.BarcodeType) {
          case btLocation : {
            return _this.compareLocation(resData.Id, callback);
          }

          break;
          case btHandlingUnit : {
            //zkontrolujeme, ze muzeme do dane MJ pridavat ... ma spravnou zonu
            services.get('handling-unit-service').isHandlingUnitValid(resData.RID, { Area: _this.origData.Area }, function (res) {
              if (!res.IsValid) {
                return app.showMessageHtml(res.Message, function () {
                  _this.confirmLocationOrHandlingUnit(callback);
                });
              }

              _this.setFormValue('HandlingUnitRID', resData.RID);

              if (!_this.settings.isReceiptProcess) {
                _this.setFormValue(_this.settings.editedLocation, resData.Abbr);
                _this.setFormValue(_this.settings.editedLocation + 'Id', 0);
              }

              invokeCallback(callback, true);
            });
          }

          break;
          default : {
            app.viewErrorMessage(app.t('barcode.unknown'));
            invokeCallback(callback, false);
          }
        }
      });
    }

    return _this;
  },

  isRequiredScanLocationOrHandlingUnit: function isRequiredScanLocationOrHandlingUnit() {
    var _this = this;

    if (_this.settings.isPickingProcess) {
      return false;
    }

    if (_this.getAmount() === 0) {
      return false;
    }

    if (_this.settings.isReceiptProcess) {
      if (!services.get('warehouse-service').isHandlingUnitRecord(_this.getWarehouseId())) {
        return false;
      }

      if (_this.settings.isLocationScanned) {
        return false;
      }

      if (_this.isMismatch()) {
        return false;
      }

      return true;
    } else {
      if (!services.get('warehouse-service').isLocationRecord(_this.getWarehouseId())) {
        return false;
      }

      if (!services.get('warehouse-service').isRequiredConfirmLocation(_this.getWarehouseId())) {
        return false;
      }

      if (_this.settings.isReceiptProcess) {
        return false;
      }

      if (!_this.settings.requiredConfirmLocation) {
        return false;
      }

      var locationId = _this.getFormFloatValue(_this.settings.editedLocation + 'Id');

      return locationId === 0;
    }
  },

  scanLocationOrHandlingUnit: function scanLocationOrHandlingUnit(callback) {
    var _this = this;

    if (!_this.settings.isReceiptProces && _this.settings.editedLocation === 'FromLocation') {
      _this.insertLocation(callback);
    } else {
      services.get('barcode-service').scanAndFind(app.t('barcode.scan_location_or_handling_unit'), app.param('active_warehouse_id'), function (res, resData) { //nepredavame sklad!
        if (res !== resSuccess) {
          return;
        }

        switch (resData.BarcodeType) {
          case btLocation : {
            if (isEmpty(resData.Id)) {
              app.viewErrorMessage('Nepodařilo se správně načíst umístění! Kontaktujte vedoucího skladu a předejte na IT oddělení. Děkuji.');
            } else {
              var srcData = _this.getSrcDataForLocation();
              srcData.StockId = resData.WarehouseId; //musim si predat novy sklad kvuli kontrolam
              srcData.Location = resData.Abbr;
              srcData.LocationId = resData.Id;

              _this.locationService.loadByBarcode(srcData, function (res, resData) {
                if (res === resSuccess) {
                  if (resData.LocationId) {
                    _this.setFormValue(_this.settings.editedLocation, resData.Location);
                    _this.setFormValue(_this.settings.editedLocation + 'Id', resData.LocationId);
                    _this.setFormValue('AreaId', resData.AreaId);
                    _this.setFormBoolValue('IsFromLocationOneArticle', resData.IsOneArticle);

                    _this.settings.isLocationScanned = true;
                    _this.settings.isArticleScanned = false;
                    _this.settings.isBatchChoosen = false;

                    invokeCallback(callback, true);
                  }
                }
              });
            }
          }

          break;
          case btHandlingUnit : {
            //zkontrolujeme, ze muzeme do dane MJ pridavat ... ma spravnou zonu
            services.get('handling-unit-service').isHandlingUnitValid(resData.RID, { Area: _this.origData.Area }, function (res) {
              if (!res.IsValid) {
                return app.showMessageHtml(res.Message, function () {
                  _this.scanLocationOrHandlingUnit(callback);
                });
              }

              _this.setFormValue('HandlingUnitRID', resData.RID);

              if (!_this.settings.isReceiptProcess) {
                _this.setFormValue(_this.settings.editedLocation, resData.Abbr);
                _this.setFormValue(_this.settings.editedLocation + 'Id', 0);
              }

              invokeCallback(callback, true);
            });
          }

          break;
          default : {
            app.viewErrorMessage(app.t('barcode.unknown'));
            invokeCallback(callback, false);
          }
        }
      });
    }

    return _this;
  },

  isRequiredInsertAmount: function isRequiredInsertAmount() {
    var _this = this;

    if (_this.settings.isReceiptProces) {
      return false;
    }

    if (_this.settings.editedLocation !== 'FromLocation') {
      return false;
    }

    if (!_this.settings.requiredInsertAmount) {
      return false;
    }

    return true;
  },

  isRequiredSafetyElement: function isRequiredSafetyElement() {
    var _this = this;

    return _this.$container.find('[name$="[IsRequiredSafetyElement]"]').val() === '1';
  },

  //-----------------------------------------------------------------

  doConfirmBatch: function doConfirmBatch() {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (_this.isRequiredChooseBatch()) {
        //pokud se nejedna o jednodruhove umisteni - musim vybrat pozadovane baleni

        _this.chooseRequiredPackage(function (isChoosen) {
          if (isChoosen) {
            resolve();
          } else {
            reject();
          }
        });
      } else {
        resolve();
      }
    });
  },

  doValidateForm: function doValidateForm() {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (_this.isFormValid()) {
        resolve();
      } else {
        reject();
      }
    });
  },

  doPrintArticleEan: function doPrintArticleEan() {
    var _this = this;

    return new Promise(function (resolve/*, reject*/) {
      if (_this.origData.IsRequiredOwnEAN && !_this.isArticleEanPrinted) {
        app.printer.printArticleEan(_this.getWebDocumentItemRID(), { Package: _this.getPackage(), SerialNumber: _this.getSerialNumber(), SerialNumberSize: _this.getSerialNumberSize() }, function () {
          resolve();
        });
      } else {
        resolve();
      }
    });
  },

  doScanLocationOrHandlingUnit: function doScanLocationOrHandlingUnit() {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (_this.isRequiredScanLocationOrHandlingUnit()) {
        _this.scanLocationOrHandlingUnit(function (isScanned) {
          if (isScanned) {
            resolve();
          } else {
            reject();
          }
        });
      } else {
        resolve();
      }
    });
  },

  doConfirmLocationOrHandlingUnit: function doConfirmLocationOrHandlingUnit() {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (_this.isRequiredConfirmLocationOrHandlingUnit()) {
        _this.confirmLocationOrHandlingUnit(function (isConfirmed) {
          if (isConfirmed) {
            resolve();
          } else {
            reject();
          }
        });
      } else {
        resolve();
      }
    });
  },

  doConfirmArticle: function doConfirmArticle() {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (_this.isRequiredConfirmArticle()) {
        _this.confirmArticle(function (isConfirmed) {
          if (isConfirmed) {
            resolve();
          } else {
            reject();
          }
        });
      } else {
        resolve();
      }
    });
  },

  doInsertAmount: function doInsertAmount() {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (_this.isRequiredInsertAmount()) {
        _this.insertAmount(function (isInserted) {
          if (isInserted) {
            resolve();
          } else {
            reject();
          }
        });
      } else {
        resolve();
      }
    });
  },

  doAutoFillLocation: function doAutoFillLocation() {
    var _this = this;

    return new Promise(function (resolve) {
      if (_this.settings.isReceiptProcess) {
        _this.doGenerateLocation(function (/*isGenerated*/) {
          resolve();
        });
      } else {
        resolve();
      }
    });
  },

  initSafetyElement: function initSafetyElement() {
    var _this = this;

    if (_this.isRequiredSafetyElement()) {
      _this.addOnScreenMessage('warning', app.t('item_form.required_safety_element'));
    }

    return _this;
  },

  doCheckAmount: function doCheckAmount() {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (_this.settings.isTransferNoteProcess && _this.getAmount() === 0) {
        app.confirmHtml(app.t('item_form.amount_is_zero'), function (ret) {
          if (ret) {
            if (_this.origAmount !== 0) {
              _this.saveMismatch(app.param('low_amount_mismatch_id'), app.param('low_amount_mismatch_title'));
            }

            resolve();
          } else {
            reject();
          }
        });
      } else {
        resolve();
      }
    });
  },

  doCheckWeight: function doCheckWeight() {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (_this.settings.isReceiptProcess && (_this.origData.UnitWeightNetto <= 0 || _this.origData.UnitWeightBrutto <= 0)) {
        app.viewErrorMessage(app.t('item_form.weight_is_required'), function () {
          reject();
        });
      } else {
        resolve();
      }
    });
  },

  doSave: function doSave() {
    var _this = this;

    var result = {
      Amount: _this.getAmount(),
      Mismatch: _this.getMismatch(),
      Location: _this.$container.find('[name$="[' + _this.settings.editedLocation + ']"]').val(),
      LocationId: _this.$container.find('[name$="[' + _this.settings.editedLocation + 'Id]"]').val(),
      HandlingUnitRID: _this.$container.find('[name$="[HandlingUnitRID]"]').val(),
      AreaId: _this.$container.find('[name$="[AreaId]"]').val(),
      IsIncreasedAmount: _this.$container.find('[name$="[IsIncreasedAmount]"]').val(),
      IsReleased: _this.$container.find('[name$="[IsReleased]"]').val(),
      Package: _this.getPackage(),
      PackageUnits: _this.getPackageUnits(),
      PackageCount: _this.getPackageCount(),
      UnitWeightNetto: _this.origData.UnitWeightNetto, //vratime si vahu. ta se mohla u prijmu zmenit, musime si ji aktualizovat
      UnitWeightBrutto: _this.origData.UnitWeightBrutto, //vratime si vahu. ta se mohla u prijmu zmenit, musime si ji aktualizovat
    };

    if (_this.settings.saveCallBack) {
      _this.settings.saveCallBack(result);
    }

    _this.deinitForm();

    _this.confirm.close();

    return _this;
  },

  save: function save() {
    var _this = this;

    var promise = Promise.resolve();

    if (app.param('is_pematex')) {
      promise = promise.then(function () {
        return _this.doCheckAmount();
      });
    }

    promise = promise.then(function () {
      return _this.doCheckWeight();
    });

    promise = promise.then(function () {
      return _this.doScanLocationOrHandlingUnit();
    });

    if (app.param('is_pematex')) {
      promise = promise.then(function () {
        return _this.doConfirmBatch();
      });
    }

    promise = promise.then(function () {
      return _this.doValidateForm();
    });

    promise = promise.then(function () {
      return _this.doPrintArticleEan();
    });

    promise = promise.then(function () {
      return _this.doConfirmLocationOrHandlingUnit();
    });

    promise = promise.then(function () {
      return _this.doConfirmArticle();
    });

    promise = promise.then(function () {
      _this.doSave();
    });

    return _this;
  },

  cancel: function cancel() {
    var _this = this;

    _this.deinitForm();

    _this.confirm.close();
  },

  open: function open(settings, data) {
    var _this = this;

    //pokud uz ted nejsme online, tak konec
    if (!app.internetConnectionManager.isOnline()) {
      app.internetConnectionManager.viewOfflineWarning();
      return _this;
    }

    _this.settings = $.extend({}, _this.defaultSetting, settings);

    _this.origData = data;
    _this.origData.ArticleId = parseInt(_this.origData.ArticleId);

    _this.confirm.open({
      title: app.t('item_form.title'),
      confirmCallBack: createObjectCallBack(_this, 'save'),
      confirmBtnTitle: app.t('item_form.confirm_form'),
      rejectCallBack: createObjectCallBack(_this, 'cancel'),
      rejectBtnTitle: app.t('item_form.reject_form'),
      modalClass: _this.modalClass,
      width: 'md',
      buttonsSize: 'lg',
      focusInput: false,
      content: ''
    });

    _this.confirm.block();

    //asi by chtelo nějak pořešit toto
    $.get(app.path('item_form'), data, function (res) {
      _this.confirm.unBlock();

      if (res.msg === 'SUCCESS') {
        _this.initForm(res.data);
      } else {
        app.viewErrorMessage();
        _this.confirm.close();
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
